import React from 'react'
import './footPage.css'

export default function footPage() {
  return (
    <div className='footPage'>
        <p className='footText'>
            © 2023  ALL RIGHTS RESERVED.  DESIGNED BY TAJUDEEN.
        </p>
        <div className='footSocial'>
            <img src='/images/facebook.png' alt='Facebook' className='facebook-logo' />
            <img src='/images/instagram.png' alt='Instagram' className='instagram-logo' />
            <img src='/images/X.png' alt='X' className='x-logo' />
        </div>    
    </div>
  )
}
